// extracted by mini-css-extract-plugin
export default {"homeMain":"HomeMain_homeMain__+gis6","homeMain_loaded":"HomeMain_homeMain_loaded__Szrgc"};